module.exports = __webpack_public_path__ + "img/w36.095e81a3.svg";